import { ISection, IResponse, IPageData } from 'src/interface';
import { SECTION_ID } from 'src/constants';
import PageService from 'src/services/PageService';
import { renderSections } from 'src/modules/shared/components/sections';
import ContentMoreSection from 'src/modules/content/components/sections/ContentMoreSection';
import { AdTopicSection } from 'src/modules/shared/components/ad/AdTopic';

const SECTION_MAP = {
    [SECTION_ID.ADTOPIC]: AdTopicSection,
};

export function Category({
    resp,
    isMobile = true,
    isBot = false,
}: {
    resp: IResponse<IPageData<IData>>;
    isMobile: boolean;
    isBot: boolean;
}) {
    const content = resp?.data?.content || ({} as any);

    if (isMobile) {
        return <>{renderSections(content.sections, SECTION_MAP, isBot)}</>;
    }

    return (
        <ContentMoreSection
            {...content}
            isMobile={isMobile}
            typeList="rank"
            options={content.options}
        />
    );
}

interface IData extends ISection<any> {
    sections: ISection<any>[];
}

export async function getServerSideProps(ctx: any): Promise<any> {
    return PageService.get(ctx, 'category', {
        shortUrl: ctx?.params?.slug,
        page: ctx.params?.page || 1,
    });
}

export default Category;
